import {Event} from "vue-tables-2";

const mixin = {
  data() {
    return {
      dateFilter: null,
    }
  },
  methods: {
    openDateRange() {
      let that = this
      //http://www.daterangepicker.com/#options
      $('input[name="daterange"]').daterangepicker({
        'alwaysShowCalendars': true,
        opens: 'center',
        ranges: {
          'Today': [moment(), moment()],
          'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last 30 Days': [moment().subtract(29, 'days'), moment()],
          'This Month': [moment().startOf('month'), moment().endOf('month')],
          'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        },
        locale: {
          format: 'DD/MM/YY',
          'firstDay': 0
        }
      }).on('apply.daterangepicker', (ev, picker) => {
        Event.$emit('vue-tables.filter::date', [
          picker.startDate.format('YYYY-MM-DD'), picker.endDate.format('YYYY-MM-DD')
        ]);
        // this.getRecordsByDate(picker.startDate.format('YYYY-MM-DD'), picker.endDate.format('YYYY-MM-DD'))
      })
    },
    clearDateFilter() {
      this.dateFilter = !this.dateFilter
      $('input[name="daterange"]').val('')
    },
    translateById(id, sourceData) {
      if (this[sourceData]) {
        for (let i in this[sourceData]) {
          if (this[sourceData][i].key === parseInt(id)) {
            if (this[sourceData][i]['color'] && /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(this[sourceData][i]['color'])) {
             // console.log(id+' -- '+this[sourceData][i].color+' -- '+this[sourceData][i].value);
              return `<span class="badge badge-pill   px-2" style="border: ${this[sourceData][i].color} solid 2px">${this[sourceData][i].value}</span>`
            } else {
              return `<span class="badge badge-pill  text-white bg-color-6 px-2" >${this[sourceData][i].value}</span>`
            }
          }
        }
      } else {
        for (let i in sourceData) {
          if (sourceData[i].key === id) {
            return `<span>${sourceData[i].value}</span>`
          }
        }
      }
      return id;
    },
    getFieldOptions(itemOptions) {
      if (itemOptions === 'statuses') {
        return this.statuses
      } else {
        return this.tconfig.options&& this.tconfig.options[itemOptions] ? this.tconfig.options[itemOptions] : itemOptions
      }
    },
    cleanFilters(){

    },
    doCustomFilter(filter, key) {
      this.selectedCustomFilter = key
      Event.$emit('vue-tables.filter::'+filter, key);
    },
  }
}

export default mixin;
